import { render, staticRenderFns } from "./AddPartiesPopup.vue?vue&type=template&id=5707f9a0"
import script from "./AddPartiesPopup.vue?vue&type=script&lang=js"
export * from "./AddPartiesPopup.vue?vue&type=script&lang=js"
import style0 from "./AddPartiesPopup.vue?vue&type=style&index=0&id=5707f9a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports